<template>
  <div ref="performerBg" class="performer-experimental-wrapper">
    <loading v-if="displayProgress" />
    <sign-up-modal v-if="isOpenSignUpModal" @onClickBg="toggleSignUpModal" signUp>
      <div class="sign-up-modal-inner">
        <p class="description">
          この操作にはログインが必要です
        </p>
        <div class="btns-wrapper">
          <button class="sign-up" type="button" @click="routerPush(sign_up_path)">会員登録をする</button>
          <p class="sign-in" @click="routerPush(sign_in_path)">ログイン</p>
        </div>
      </div>
    </sign-up-modal>
    <section v-if="performerData.cover_image_path" class="performer-cover-img" :style="{ backgroundImage: 'url(' + performerData.cover_image_path + ')' }" />
    <section class="performer-curation-data-wrapper" ref="performerCurationDataWrapper">
      <div :class="['performer-info-wrapper', { 'no-header': !performerData.cover_image_path }]">
        <performer-info
          v-if="loaded"
          :performerId="performerData.id"
          :performerImg="performerData.icon_image_path"
          :name="performerData.name"
          :description="performerData.view_customization.performer_view_customization.description"
          :followStatus="isFollowing"
          :textColor="performerData.view_customization.performer_view_customization.hex_performer_text_color"
          :rootUrl="root_url"
          @followPerformer="apiFollowPerformer"
        />
      </div>
      <div :class="['performer-activities-wrapper', { 'no-header': !performerData.cover_image_path }]">
        <div ref="activityTabs" class="activity-tabs-wrapper">
          <performer-activities-filter-tab
            v-if="loaded"
            :textColor="performerData.view_customization.performer_view_customization.hex_performer_text_color"
            @updateGenre="updateCurrentGenre"
          />
        </div>
        <div
          class="activity-item-wrapper"
          v-if="currentGenre === 'all' || currentGenre === 'event'"
        >
          <h2 class="activity-title">
            Event
          </h2>
          <div
            class="performer-event-item-wrapper"
            v-for="event in events"
            :key="event.id"
          >
            <performer-event-item
              :id="event.id"
              :eventImgUrl="event.image"
              :title="event.title"
              :schedule="event.play_date"
              :performers="event.performers"
              @onClickEvent="goToEventPage(event.id)"
            />
          </div>
          <div v-if="(eventsLength - events.length) > 0" class="show-more-btn-wrapper">
            <button type="button" @click="showMore('event')">More</button>
          </div>
        </div>
        <div
          class="activity-item-wrapper"
          v-if="currentGenre === 'all' || currentGenre === 'message'"
        >
          <h2 class="activity-title">
            News
          </h2>
          <div
            class="performer-message-item-wrapper"
            v-for="article in articles"
            :key="article.id"
          >
            <performer-message-item
              :id="article.id"
              :title="article.title"
              :date="article.published_date"
              :favCount="article.good_cnt"
              :commentsCount="article.comment_cnt"
              :siteUrl="article.site_url"
              :imgUrl="article.img_url"
              :description="article.description"
              :curationMedia="article.curation_media"
              :topPageUrl="article.curation_site_top_pagre_url"
              :isGood="article.is_gooded"
              :isSignedIn="is_sign_in"
              :articleCommentsAPIPath="show_curation_site_article_comments_path"
              :artilceGoodsPath="article_goods_path"
              @onClickProfile="openBlank(edit_home_path)"
              @onClickPolicy="openBlank(user_policy_path)"
              @toggleSignUpModal="toggleSignUpModal"
            />
          </div>
          <div v-if="(messagesLength - articles.length) > 0" class="show-more-btn-wrapper">
            <button type="button" @click="showMore('message')">More</button>
          </div>
        </div>
        <div
          class="activity-item-wrapper"
          v-if="currentGenre === 'all' || currentGenre === 'member'"
        >
          <h2 class="activity-title">
            Member
          </h2>
          <div class="performer-member-item-wrapper">
            <div
              class="performer-member-item-inner"
              v-for="member in performerData.members"
              :key="member.id"
            >
              <performer-member-item
                :memberImgUrl="member.img_path"
                :name="member.name"
                :description="member.description"
              />
            </div>
          </div>
        </div>
        <div
          class="activity-item-wrapper"
          v-if="currentGenre === 'all' || currentGenre === 'twitter'"
        >
          <h2 class="activity-title">
            Twitter
          </h2>
          <div class="performer-twitter-item-wrapper">
            <div
              class="performer-twitter-item-inner"
                v-for="account in performerData.twitter_accounts"
                :key="account.id"
            >
              <performer-twitter-item
                :accountId="account.account"
              />
            </div>
          </div>
        </div>
        <div
          class="activity-item-wrapper"
          v-if="currentGenre === 'all' || currentGenre === 'music'"
        >
          <h2 class="activity-title">
            Music
          </h2>
          <div
            class="performer-music-item-wrapper"
            v-for="album in spotifyAlbums"
            :key="album.id"
          >
            <performer-music-item
              :albumUrl="album.album_url"
            />
          </div>
          <div v-if="(musicLength - spotifyAlbums.length) > 0" class="show-more-btn-wrapper music">
            <button type="button" @click="showMore('music')">More</button>
          </div>
        </div>
        <div
          class="activity-item-wrapper"
          v-if="currentGenre === 'all' || currentGenre === 'movie'"
        >
          <h2 class="activity-title">
            Movie
          </h2>
          <div class="performer-movie-item-wrapper">
            <div
              class="performer-movie-item-inner"
              v-for="video in performerData.youtube_videos"
              :key="video.id"
            >
              <performer-movie-item
                :videoUrl="video.video_url"
                :title="video.title"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <curation-footer
      :topUrl="root_url"
      :signUpUrl="sign_up_path"
    />
  </div>
</template>

<script>
import consts from '../utils/consts'

// components
import PerformerInfo from './curation/PerformerInfo.vue'
import PerformerActivitiesFilterTab from './curation/PerformerActivitiesFilterTab.vue'
import PerformerEventItem from './curation/PerformerEventItem.vue'
import PerformerMessageItem from './curation/PerformerMessageItem.vue'
import PerformerMemberItem from './curation/PerformerMemberItem.vue'
import PerformerTwitterItem from './curation/PerformerTwitterItem.vue'
import PerformerMusicItem from './curation/PerformerMusicItem.vue'
import PerformerMovieItem from './curation/PerformerMovieItem.vue'
import SignUpModal from './curation/MessageModal.vue'
import Loading from './curation/CurationLoading.vue'
import CurationFooter from './curation/CurationFooter.vue'

export default {
  components: {
    PerformerInfo,
    PerformerActivitiesFilterTab,
    PerformerEventItem,
    PerformerMessageItem,
    PerformerMemberItem,
    PerformerTwitterItem,
    PerformerMusicItem,
    PerformerMovieItem,
    SignUpModal,
    Loading,
    CurationFooter
  },
  props: {
    is_sign_in: { type: Boolean, required: true },
    performer_id: { type: Number, required: true },
    show_performers_path: { type: String, required: true },
    show_performer_events_path: { type: String, required: true },
    performer_follow_path: { type: String, required: true },
    performer_un_follow_path: { type: String, required: true },
    performers_articles_path: { type: String, required: true },
    performers_spotify_albums_path: { type: String, required: true },
    show_curation_site_article_comments_path: { type: String, required: true },
    article_goods_path: { type: String, required: true },
    article_un_goods_path: { type: String, required: true },
    sign_up_path: { type: String, required: true },
    sign_in_path: { type: String, required: true },
    edit_home_path: { type: String, required: true },
    user_policy_path: { type: String, required: true },
    event_path: { type: String, required: true },
    root_url: { type: String, required: true }
  },
  data () {
    return {
      events: [],
      articles: [],
      spotifyAlbums: [],
      orgEvents: [],
      orgArticles: [],
      orgSpotifyAlbums: [],
      eventPages: 1,
      messagePages: 1,
      musicPages: 1,
      isOpenMessageModal: false,
      isOpenSignUpModal: false,
      loaded: false,
      currentY: '',
      step: '',
      intervalID: ''
    }
  },
  async created () {
    await this.getPerformerData()
    await this.getEvents()
    this.loaded = true
    this.events = this.eventsForCuration
    this.articles = this.performerData.curation_site_articles
    this.spotifyAlbums = this.performerData.spotify_albums
    // ファーストビューで表示してる記事やアルバムも用意しとく(Allに切り替えたとき用)
    this.orgEvents = this.eventsForCuration
    this.orgArticles = this.performerData.curation_site_articles
    this.orgSpotifyAlbums = this.performerData.spotify_albums
    this.$refs.performerBg.style.background = this.performerData.view_customization.performer_view_customization.hex_performer_background_color
    this.$refs.activityTabs.style.background = this.performerData.view_customization.performer_view_customization.hex_performer_background_color
  },
  computed: {
    performerData: function () {
      return this.$store.getters['performer/performerData']
    },
    isFollowing: function () {
      return this.$store.getters['performer/isFollowing']
    },
    eventsForCuration: function () {
      return this.$store.getters['performer/eventsForCuration']
    },
    eventsLength: function () {
      return this.$store.getters['performer/length']
    },
    messages: function () {
      return this.$store.getters['performer/messages']
    },
    messagesLength: function () {
      return this.$store.getters['performer/messagesLength']
    },
    messagesComments: function () {
      return this.$store.getters['curationSiteArticle/articleComments']
    },
    musics: function () {
      return this.$store.getters['performer/musics']
    },
    musicLength: function () {
      return this.$store.getters['performer/musicLength']
    },
    currentGenre: function () {
      return this.$store.getters['performer/currentGenre']
    },
    displayProgress: function () {
      return this.$store.getters['performer/displayProgress']
    }
  },
  methods: {
    openBlank: function (path) {
      window.open(this.root_url + path.slice(1), "_blank")
    },
    routerPush: function (path) {
      window.location.href = path
    },
    // キュレーションページ情報を取得
    getPerformerData: function () {
      return this.$store.dispatch('performer/getPerformerData', {api_path: this.show_performers_path})
    },
    // イベント情報を取得
    getEvents: function () {
      return this.$store.dispatch('performer/getEvents', {api_path: this.show_performer_events_path, p: this.performer_id, page: this.eventPages, per:5})
    },
    // メッセージ情報を取得
    getMessages: function () {
      return this.$store.dispatch('performer/getMessages', {api_path: this.performers_articles_path, p: this.performer_id, page: this.messagePages, per:3})
    },
    // アルバム情報を取得
    getMusic: function () {
      return this.$store.dispatch('performer/getMusic', {api_path: this.performers_spotify_albums_path, p: this.performer_id, page: this.musicPages, per:2})
    },
    // 出演者をフォロー
    followPerformer: function () {
      return this.$store.dispatch('performer/performer_follow', {api_path: this.performer_follow_path})
    },
    // フォロー解除
    performer_un_follow: function () {
      return this.$store.dispatch('performer/performer_un_follow', {api_path: this.performer_un_follow_path})
    },
    async updateCurrentGenre (genre) {
      if (genre === 'all') {
        this.eventPages = 1
        this.messagePages = 1
        this.musicPages = 1
        this.articles = this.orgArticles
        this.spotifyAlbums = this.orgSpotifyAlbums
        this.events = this.orgEvents
      }
      if (this.currentGenre !== genre) this.scrollToTop(0)
      return this.$store.dispatch('performer/updateCurrentGenre', genre)
    },
    async apiFollowPerformer () {
      if (this.is_sign_in) {
        if (this.isFollowing) {
          await this.performer_un_follow()
        } else {
          await this.followPerformer()
        }
      } else {
        this.toggleSignUpModal()
      }
    },
    toggleSignUpModal: function () {
      this.isOpenSignUpModal = !this.isOpenSignUpModal
    },
    async showMore (genre) {
      switch (genre) {
        case 'event':
          this.eventPages++
          await this.getEvents()
          const newEvents = this.eventsForCuration.concat()
          this.events = this.events.concat(newEvents)
          break
        case 'message':
          this.messagePages++
          await this.getMessages()
          const newMessages = this.messages.concat()
          this.articles = this.articles.concat(newMessages)
          break
        case 'music':
          this.musicPages++
          await this.getMusic()
          const newMusics = this.musics.concat()
          this.spotifyAlbums = this.spotifyAlbums.concat(newMusics)
          break
      }
      this.updateCurrentGenre(genre)
    },
    goToEventPage: function (id) {
      window.location.href = this.event_path + id
    },
    scrollUp: function () {
      this.currentY = window.pageYOffset
      if(this.currentY === 0) {
        clearInterval(this.intervalID)
      } else {
        scrollBy( 0, -this.step )
      }
    },
    scrollToTop: function (duration) {
      this.currentY = window.pageYOffset
      this.step = duration/this.currentY > 1 ? 10 : 100
      const timeStep = duration/this.currentY * this.step
      this.intervalID = setInterval(this.scrollUp, timeStep)
    }
  }
}
</script>


<style lang="scss" scoped>
$breakpoint: 767px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
  .performer-experimental-wrapper {
    background-color: #f7f7f7;
    .performer-cover-img {
      background-repeat: no-repeat;
      background-size: cover;
      height: 300px;

      @media screen and (max-width: $breakpoint) {
        height: 80px;
      }
    }
    .performer-curation-data-wrapper {
      display: flex;
      justify-content: space-between;
      max-width: 1100px;
      margin: 0 auto;

      @media screen and (max-width: 1200px) {
        padding: 0 10px;
      }

      @media screen and (max-width: $breakpoint) {
        flex-direction: column;
        padding: 0;
      }
      .performer-info-wrapper {
        margin-top: -170px;

        @media screen and (max-width: $breakpoint) {
          margin-top: -35px;
          margin-right: 0;
          padding: 0 20px;
        }

        &.no-header {
          margin-top: 60px;

          @media screen and (max-width: $breakpoint) {
            margin-top: 20px;
          }
        }
      }
      .performer-activities-wrapper {
        flex-shrink: 0;
        width: calc(100% - 300px);
        margin-top: 45px;

        @media screen and (max-width: $breakpoint) {
          min-width: 100%;
          margin-top: 10px;
        }

        &.no-header {
          margin-top: 60px;

          @media screen and (max-width: $breakpoint) {
            margin-top: 0;
          }
        }
        .activity-tabs-wrapper {
          background-color: #f7f7f7;
          margin-bottom: 30px;

          @media screen and (max-width: $breakpoint) {
            position: sticky;
            top: 0;
            margin-bottom: 0;
            padding-top: 20px;
          }
        }
        .activity-item-wrapper {
          background-color: #fff;
          padding: 30px;
          margin-bottom: 20px;

          @media screen and (max-width: $breakpoint) {
            padding: 30px 20px;
            margin-bottom: -30px;
          }
          .activity-title {
            text-align: left;
            color: #000;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            padding-bottom: 0;
            @media screen and (max-width: $breakpoint) {
              margin-bottom: 15px;
            }
          }
          .show-more-btn-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 20px;

            &.music {
              margin-top: -10px;
            }

            button {
              border: 1px solid #c8c8c8;
              border-radius: 4px;
              color: #666;
              font-size: 13px;
              width: 160px;
              height: 38px;
              transition: .2s;

              &:hover {
                opacity: 0.7;
              }
            }
          }
          .performer-event-item-wrapper {
            margin-bottom: 15px;
          }

          .performer-message-item-wrapper {
            border-bottom: 1px solid #e6e6e6;
            padding-bottom: 15px;
            margin-bottom: 15px;
          }

          .performer-member-item-wrapper {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .performer-member-item-inner {
              margin-bottom: 20px;
              width: 47%;

              @media screen and (max-width: 900px) {
                width: 100%;
              }

              @media screen and (max-width: $breakpoint) {
                margin-bottom: 15px;

                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }

          .performer-twitter-item-wrapper {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            @media screen and (max-width: $breakpoint) {
              padding: 0 20px
            }
            .performer-twitter-item-inner {
              margin-bottom: 30px;

              @media screen and (max-width: $breakpoint) {
                width: 100%;
                margin-bottom: 15px;
              }
            }
          }

          .performer-music-item-wrapper {
            margin-bottom: 30px;

            &:last-of-type {
              margin-bottom: 0;
            }
          }

          .performer-movie-item-wrapper {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .performer-movie-item-inner {
              margin-bottom: 20px;
              width: 47%;

              @media screen and (max-width: 900px) {
                width: 100%;
              }

              @media screen and (max-width: $breakpoint) {
                margin-bottom: 15px;

              }
            }
          }
        }
      }
    }

    .sign-up-modal-inner {
      .description {
        font-size: 20px;
        text-align: center;
        margin-bottom: 40px;
      }
      .btns-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        .sign-up {
          color: #fff;
          font-size: 16px;
          font-weight: bold;
          background: #3c8c8c;
          width: 280px;
          height: 50px;
          margin-bottom: 30px;
          text-align: center;
          transition: .2s;

          &:hover {
            opacity: 0.7;
          }
        }
        .sign-in {
          cursor: pointer;
          color: #666;
          transition: .2s;

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }
  }
</style>
